// **************************
// CV TYPE
// **************************

export const getCVTypeList = (language) => {
    switch (language) {
        case 'pt':
            return CV_TYPE_LIST;
        break;
        case 'en':
            return EN_CV_TYPE_LIST;
        break;
        case 'es':
            return ES_CV_TYPE_LIST;
        break;
        case 'fr':
            return FR_CV_TYPE_LIST;
        break;
        default:
            break;
    }
}

export const getCVTypeUrl = (language) => {
    switch (language) {
        case 'pt':
            return CV_URL_OPTION;
        break;
        case 'en':
            return EN_CV_URL_OPTION;
        break;
        case 'es':
            return ES_CV_URL_OPTION;
        break;
        case 'fr':
            return FR_CV_URL_OPTION;
        break;
        default:
            break;
    }
}

export const isCVTypeUrl = (cvType) => {
    if (cvType === null || cvType === undefined) return false;

    return cvType.code === CV_URL_OPTION.code;
}

export const getCVTypeFile = (language) => {
    switch (language) {
        case 'pt':
            return CV_FILE_OPTION;
        break;
        case 'en':
            return EN_CV_FILE_OPTION;
        break;
        case 'es':
            return ES_CV_TYPE_LIST;
        break;
        case 'fr':
            return FR_CV_TYPE_LIST;
        break;
        default:
            break;
    }
}

export const isCVTypeFile = (cvType) => {
    if (cvType === null) return false;

    return cvType.code === CV_FILE_OPTION.code;
}

// PT Version

export const CV_FILE_OPTION = { name: 'Ficheiro (.pdf)', code: 'Ficheiro (.pdf)' };
export const CV_URL_OPTION = { name: 'URL (um link externo)', code: 'URL (um link externo)' };

export const CV_TYPE_LIST = [
    CV_FILE_OPTION,
    CV_URL_OPTION
];

// EN Version

export const EN_CV_FILE_OPTION = { name: 'File (.pdf)', code: 'Ficheiro (.pdf)' };
export const EN_CV_URL_OPTION = { name: 'URL (external link)', code: 'URL (um link externo)' };

export const EN_CV_TYPE_LIST = [
    EN_CV_FILE_OPTION,
    EN_CV_URL_OPTION
];

// ES Version

export const ES_CV_FILE_OPTION = { name: 'Archivo (.pdf)', code: 'Ficheiro (.pdf)' };
export const ES_CV_URL_OPTION = { name: 'URL (un enlace externo)', code: 'URL (un link externo)' };

export const ES_CV_TYPE_LIST = [
    ES_CV_FILE_OPTION,
    ES_CV_URL_OPTION
];

// FR Version

export const FR_CV_FILE_OPTION = { name: 'Fichier (.pdf)', code: 'Ficheiro (.pdf)' };
export const FR_CV_URL_OPTION = { name: 'URL (un lien externe)', code: 'URL (un link externo)' };

export const FR_CV_TYPE_LIST = [
    FR_CV_FILE_OPTION,
    FR_CV_URL_OPTION
];